/**
 * @author Fernando Ruano
 * @file routes.js
 * @description Patient routes
 */

// Pages
import DetailsView from '@nephro/pages/MyRecommendations/DetailsView';
import MainView from '@nephro/pages/MyRecommendations/MainView';

const pathStart = '/main/patient-my-recomendations';
const routes = [
  {
    path: `${pathStart}`,
    isProtected: true,
    component: MainView,
    exact: true
  },
  {
    path: `${pathStart}/details`,
    isProtected: true,
    component: DetailsView,
    exact: true
  },
  { redirect: true, to: `${pathStart}` }
];

export default routes;
